export default __webpack_public_path__ + "../staticImages/btn-paypal.svg";